import React, { Component } from 'react';
import './LoadingSpinner.scss';

class LoadingSpinner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentProviderIndex: 0
        };
        this.providers = [
            { name: 'Openreach', logo: '/images/providers/openreach.svg' },
            { name: 'CityFibre', logo: '/images/providers/cityfibre.svg' },
            { name: 'OFNL', logo: '/images/providers/ofnl.svg' },
            { name: '1310', logo: '/images/providers/1310.svg' }
        ];
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState(prevState => ({
                currentProviderIndex: (prevState.currentProviderIndex + 1) % this.providers.length
            }));
        }, 1500);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render() {
        const { title, message } = this.props;
        const currentProvider = this.providers[this.state.currentProviderIndex];

        return (
            <div className="loading-spinner-container">
                <div className="loading-content">
                    <h1 className="loading-title">{title || 'Loading Available Services'}</h1>

                    <div className="provider-logo-container">
                        <div className="provider-logo-wrapper">
                            <img
                                src={currentProvider.logo}
                                alt={currentProvider.name}
                                className="provider-logo"
                                key={this.state.currentProviderIndex}
                            />
                        </div>
                        <div className="loading-dots">
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                        </div>
                    </div>

                    {message && (
                        <p className="loading-message">{message}</p>
                    )}

                    <p className="loading-subtitle">
                        Checking availability across multiple networks
                    </p>
                </div>
            </div>
        );
    }
}

export default LoadingSpinner;
